import { render } from "./BaseArchiveRestoreButton.vue?vue&type=template&id=4dc83ff8"
import script from "./BaseArchiveRestoreButton.vue?vue&type=script&lang=js"
export * from "./BaseArchiveRestoreButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__